export const REDASH_STUDENT_LIST_QUERY_ID = 78
export const TEACHER_STUDENTS_LIST_QUERY_KEY =
  'zggZJLXt3uhdAmgSQ7mZcQQz3P9ZuqLthoixtCcz'
export const TEACHER_STUDENTS_API_URL = '/api/v1/analytics/teacher-students/'

export enum CourseClassCancellationModalStatesEnum {
  checkIfStudentIsInformed = 'checkIfStudentIsInformed',
  /** Before 2 hours */
  earlyCancellation = 'earlyCancellation',
  /** After 2 hours */
  lateCancellation = 'lateCancellation',
  success = 'success',
  requestTeacherToInformStudent = 'requestTeacherToInformStudent',
}

export const CALENDAR_IMAGE_PATH = '/images/teacher-dashboard/calendar/'

export enum TrialClassCancellationModalStatesEnum {
  /** Before 2 hours */
  confirmCancellation = 'confirmCancellation',
  /** After 2 hours */
  confirmLateCancellation = 'confirmLateCancellation',
  failedDueToNoAvailableSlots = 'failedDueToNoAvailableSlots',
  /** Cancelling 15min after from start time */
  failedDueToVeryLateCancellation = 'failedDueToVeryLateCancellation',
  success = 'success',
}

/** In minutes */
export const TRIAL_CLASS_LATE_CANCELLATION_THRESHOLDS = {
  late: 120,
  veryLate: 15,
}

export const TEACHER_SERVICE_DESK_URL =
  'https://codingal-help-support.atlassian.net/servicedesk/customer/portals'

export enum OnCancelResultEnum {
  success = 'success',
  failed = 'failed',
  slotsNotAvailable = 'slotsNotAvailable',
}

export const CANCEL_CLASS_NO_ALTERNATE_SLOT_MESSAGE_FROM_API_ON_404 =
  'Alternate slot not available'
